import WebRequest from "./WebRequest";
import NotifiablePromise from "../types/system/NotifiablePromise{}";
import Configuration from "../foundation/Configuration";

class Datastore extends WebRequest {
    protected static get includeAuth(): boolean {
        return true;
    }

    static override get basePath(): string {
        return `${Configuration.servicesPath}/`;
    }

    static check(): NotifiablePromise<boolean> {
        return this.get("api/Authentication/Session/IsSSO");
    }
}

export default Datastore;
